exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".newForm {\r\n    box-sizing: border-box;\r\n    background-color: #ffffff;\r\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\r\n    font: bold 14px sans-serif;\r\n    text-align: center;\r\n    color: #333;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/ESealStore_AJS/src/app/components/signup/signup.component.css
// module id = ../../../../../src/app/components/signup/signup.component.css
// module chunks = main